module.exports = __webpack_public_path__ + "img/surveyResponseBreakDown.5af72862.png";